module.exports = __webpack_public_path__ + "static/media/044-implant.587f583e.svg";